type ProductHealthcareDocument = {
  label: string;
  href: string;
};

export const PRODUCT_HEALTHCARE_DOCUMENTS_BY_SLUG: Record<
  string,
  ProductHealthcareDocument
> = {
  'maksitran-rozchyn-d-in-100-mh-ml-amp-5-ml-5': {
    label: 'Звернення до спеціалістів системи охорони здоров’я',
    href: 'https://backend.microkhim.com.ua/app/uploads/2026/07/dhpc-maksitran-june-2026.pdf',
  },
  'maxitran-solution-for-injection-100-mg-ml-in-ampoules-5-ml-no-5': {
    label: 'Information letter to healthcare professionals',
    href: 'https://backend.microkhim.com.ua/app/uploads/2026/07/dhpc-maksitran-june-2026.pdf',
  },
} as const;
